import 'regenerator-runtime/runtime';

import * as system from 'reakit-system-bootstrap';

// eslint-disable-next-line sort-imports
import { FunctionalComponent, render } from 'preact';

import GlobalStyle from './components/GlobalStyle';
import Helmet from 'react-helmet';
import NotFound from './views/NotFound';
import Preview from './views/Preview';
import { Provider } from 'reakit';
import Router from 'preact-router';

const root = document.getElementById('root');

const Main: FunctionalComponent = () => (
  <Provider unstable_system={system}>
    <GlobalStyle />
    <Helmet title="Usercentrics preview" />
    <Router>
      <Preview
        path={`${window.location.pathname.replace(
          'index.html',
          '',
        )}:settingsId?sandbox?legacy?view?bundleSource?version?device?cmpVersion?abVariant?`}
      />
      <NotFound type="404" default />
    </Router>
  </Provider>
);

if (root) {
  render(<Main />, root);
} else {
  throw new Error("The element #root wasn't found");
}
